module.exports = __webpack_public_path__ + "static/img/iso27001.9032905a.jpg";